import React, { Fragment, useState, useContext } from 'react';
import { Link } from "react-router-dom";
import { Collapse } from 'react-bootstrap';
import Loanprogress from './Loanprogress';
import Loandetails from './Loandetails';
import { AppContext } from '../../../AppContext';

const Content = () => {
    const { appState } = useContext(AppContext);
    const dashboard = appState.dashboard || {};
    const [open, setOpen] = useState(true);

    return (
        <Fragment>
            <section className="section-padding user-dashboard-sec bg-gray">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="dashboard-first-sec">
                                <div className="row">
                                    <div className="col-lg-6 align-self-center">
                                        <div className="left-side mb-md-80">
                                            <h3><Link to="#" className="text-custom-black">{dashboard.companyUrl}</Link></h3>
                                            <h5 className="no-margin fw-600">
                                                <Link
                                                    to="#"
                                                    className="text-custom-blue"
                                                    onClick={() => setOpen(!open)}
                                                    aria-controls="user-profile"
                                                    aria-expanded={open}
                                                >
                                                    {dashboard.loanProfileLabel}
                                                </Link>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="right-side">
                                            <ul className="custom">
                                                {dashboard.iconFeatures?.map((item, idx) => (
                                                    <li key={idx}>
                                                        <div className="icon-box">
                                                            <img src={process.env.PUBLIC_URL + item.icon} alt="icon" />
                                                        </div>
                                                        <p className="text-custom-black">{item.text}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-padding user-dashboard-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Collapse in={open}>
                                <div className="user-loan-profile">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="welcome-box mb-md-40">
                                                <div className="icon-box">
                                                    <img src={process.env.PUBLIC_URL + "/assets/images/faq-user.png"} alt="icon" />
                                                </div>
                                                <div className="welcome-text">
                                                    <h4 className="text-custom-black">{dashboard.welcomeTitle}</h4>
                                                    <p className="text-custom-black">{dashboard.welcomeMessage}</p>
                                                    <Link to="#" className="text-custom-blue fw-600 fs-14">{dashboard.viewHistoryLabel}</Link>
                                                </div>
                                            </div>
                                        </div>
                                        {dashboard.stat?.map((statItem, idx) => (
                                            <div key={idx} className={`col-lg-${idx === 0 ? '2 col-sm-4' : '6 col-sm-8'}`}>
                                                <div className="loan-box-wrap">
                                                    <div className="content">
                                                        <h2 className="text-custom-black fw-600">{statItem.value}</h2>
                                                        <p className="no-margin text-custom-black">{statItem.label}</p>
                                                    </div>
                                                    {(statItem.extraLabel || statItem.extraValue) && (
                                                        <div className="content-infor">
                                                            <ul className="custom">
                                                                {statItem.extraLabel && <li>{statItem.extraLabel} <Link to="#">{statItem.extraValue}</Link></li>}
                                                                {dashboard.detailsLinks && (
                                                                    <>
                                                                        <li><Link to="#">{dashboard.detailsLinks.monthly}</Link></li>
                                                                        <li><Link to="#">{dashboard.detailsLinks.yearly}</Link></li>
                                                                    </>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="close-btn" onClick={() => setOpen(!open)} aria-controls="user-profile" aria-expanded={open}>
                                            <Link to="#"><i className="fas fa-times" /></Link>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                        <Loanprogress />
                        <Loandetails />
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default Content;
